/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidationError } from './ValidationError';
import {
    ValidationErrorFromJSON,
    ValidationErrorFromJSONTyped,
    ValidationErrorToJSON,
    ValidationErrorToJSONTyped,
} from './ValidationError';

/**
 * 
 * @export
 * @interface ValidationErrorsKind
 */
export interface ValidationErrorsKind {
    /**
     * 
     * @type {{ [key: string]: ValidationErrorsKind; }}
     * @memberof ValidationErrorsKind
     */
    nested?: { [key: string]: ValidationErrorsKind; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: ValidationErrorsKind; }; }}
     * @memberof ValidationErrorsKind
     */
    list?: { [key: string]: { [key: string]: ValidationErrorsKind; }; } | null;
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof ValidationErrorsKind
     */
    field?: Array<ValidationError> | null;
}

/**
 * Check if a given object implements the ValidationErrorsKind interface.
 */
export function instanceOfValidationErrorsKind(value: object): value is ValidationErrorsKind {
    return true;
}

export function ValidationErrorsKindFromJSON(json: any): ValidationErrorsKind {
    return ValidationErrorsKindFromJSONTyped(json, false);
}

export function ValidationErrorsKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationErrorsKind {
    if (json == null) {
        return json;
    }
    return {
        
        'nested': json['nested'] == null ? undefined : (mapValues(json['nested'], ValidationErrorsKindFromJSON)),
        'list': json['list'] == null ? undefined : json['list'],
        'field': json['field'] == null ? undefined : ((json['field'] as Array<any>).map(ValidationErrorFromJSON)),
    };
}

export function ValidationErrorsKindToJSON(json: any): ValidationErrorsKind {
    return ValidationErrorsKindToJSONTyped(json, false);
}

export function ValidationErrorsKindToJSONTyped(value?: ValidationErrorsKind | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nested': value['nested'] == null ? undefined : (mapValues(value['nested'], ValidationErrorsKindToJSON)),
        'list': value['list'],
        'field': value['field'] == null ? undefined : ((value['field'] as Array<any>).map(ValidationErrorToJSON)),
    };
}

